module.exports = {
  // 界面
  refresh: '刷新',
  the_side_slip: '侧边伸缩',
  close_current_tab: '关闭当前标签页',
  close_other_tab: '关闭其它标签页',
  close_all_tab: '关闭全部标签页',

  //类别
  add_next_level: '新增下一级',
  add_same_level: '新增同一级',
  parent_category: '上级分类',

  //通用
  new: '新增',
  copy_new: '复制新增',
  choose_new: '选择新增',
  edit: '修改',
  delete: '删除',
  batch_delete: '批量删除',
  ok: '确定',
  save: '保存',
  copy: '复制',
  save_and_copy: '保存并复制',
  confirm_and_copy: '确定并复制',
  cancel: '取消',
  reset: '重置',
  refresh: '刷新',
  input_search_content: '输入查询内容...',
  name: '名称',
  name2: '姓名',
  full_name: '姓名',
  full_name2: '全称',
  is_valid: '是否有效',
  yes: '是',
  no: '否',
  none: '没有',
  have: '有',
  nothing: '无',
  infomation: '信息',
  remark: '备注',
  description: '描述',
  serial_no: '流水号',
  close: '关闭',
  audit: '审核',
  unaudit: '反审',
  color: '颜色',
  color2: '颜料',
  is_cash: '是否现金',
  is_default: '是否默认',
  print: '打印',
  reprint: '重印',
  import: '导入',
  export: '导出',
  menu: '菜单',
  quotation: '报价单',
  message: '信息',
  quote_item: '报价项目',
  preview: '预览',
  download: '下载',
  batch: '批次',
  plan_no: '计划单号',
  result: '结果',
  image: '图片',
  content: '内容',
  content2: '正文',
  introduction: '简介',
  sort_order: '排序',
  choose_image: '选择图片',
  choose_file: '选择文件',
  no_nodes: '没有节点',

  //通用功能接口
  supplier_category: '供应商分类',
  supplier: '供应商',
  client: '客户',
  payment_method: '结算方式',
  payment_method2: '支付方式',
  warehouse: '仓库',
  code: '编码',
  code2: '代码',
  model: '型号',
  bracket_model: '支架型号',
  standard: '规格',
  unit: '单位',
  category: '分类',
  goods_category: '货品分类',
  goods_category2: '商品分类',
  positions: '仓位',
  date: '日期',
  please_choose: '请选择',
  invoice_no: '发票号',
  po_no: '采购单号',
  po_no2: 'PO No.',
  view: '查看',
  goods: '货品',
  goods2: '商品',
  org_name: '机构名称',
  org: '机构',
  total: '合计',
  retail_price: '零售价',
  retail_price2: '零售价2',
  mini_retail_price: '最低零售价',
  consignment_price: '寄卖价',
  login: '登录',
  logout: '注销',
  change_password: '修改密码',
  the_front: '前台',
  the_back: '后台',

  contacts: '联系人',
  contact_person: '联系人',
  contacts_department: '联系人部门',
  contacts_post: '联系人职位',
  post: '岗位',
  mobile: '手机',
  office_phone: '办公电话',
  fax: '传真',
  email: '电子邮箱',
  post_code: '邮递区号',
  zip_code: '邮政编码',
  address: '地址',
  address2: '住址',
  website: '网址',
  website2: '网站',
  bank_account: '银行账户',
  accounts_receivable: '应收账款',
  accounts_payable: '应付账款',

  workshop: '车间',
  phone: '电话',
  principal: '负责人',

  accountbook: '帐簿',
  ticket_number: '票据号',

  cost: '成本',
  total_cost: '总成本',
  brand: '品牌',
  barcode: '条形码',
  barcode2: '条形码',
  qrcode: '二维码',
  imei: 'IMEI',

  search: '搜索',
  auto_search: '自动搜索',
  manual_search: '手动搜索',
  confirm: '确定',
  discount: '折扣',
  sell_price: '销售价',
  seller: '售货员',
  member: '会员',
  member_name: '会员姓名',
  goods_search: '货品查找',
  hold_receipt: 'Hold单',
  unchecked: '未结账',
  order: '预订',
  order_report: '预订报表',
  pay_money: '付款金额',
  paid_money: '已付金额',
  unpaid_money: '未付金额',

  in_warehouse: '转入仓库',
  out_warehouse: '转出仓库',

  sundry_category: '杂项分类',
  money: '金额',
  is_tax: '含税',
  tax_amount: '含税金额',
  tax_point: '税点',
  tax_rate: '税率',
  profit: '利润',
  profit_rate: '利润率',
  profit_rate2: '利率',

  user_group: '用户组',
  user: '用户资料',
  is_see_money: '查看金额',
  is_see_cost: '查看成本',
  is_stock_reminder: '库存提醒',
  is_expired_reminder: '过期提醒',

  is_front: '可用前台',
  remember_login_name: '记住登录名',
  remember_password: '记住密码',
  expiry_date: '到期日期',
  cashier: '收银员',
  is_hold: '是否Hold单',
  is_order: '是否预订',
  walk_in: '散客',
  amount_received: '已收金额',
  discount_money: '折扣金额',
  payment: '付款',
  settle: '结账',
  obsolete: '作废',
  exchange: '换货',
  return: '退货',
  return2: '返回',
  return_and_exchange: '退/换 货',
  total_quantity: '合计数量',
  change: '找赎',
  total_amount: '总金额',
  pay_money: '实收金额',
  upload: '上传',
  fuzzy_query: '模糊查询',
  shelf_lift: '保质期',
  maintenance_period: '保养期',
  to_warehouse: '转到仓库',
  from_warehouse: '来自仓库',
  stock_transfer_in: '转仓入',
  summary_data: '汇总数据',
  detail_data: '明细数据',
  shop: '店铺',
  item: '项目',
  source_quantity: '原数量',
  confirm_and_stay: '确定并停留',
  total_quantity: '总数量',
  confirm_password: '确定密码',

  delivery_person: '送货员',
  status: '状态',
  state: '状态',
  stock_state: '库存状态',
  order_date: '订单日期',
  order_time: '订单时间',
  order_date2: '落单日期',
  order_time2: '开单时间',
  order_date3: '接单日期',
  order_time4: '下单时间',
  order_date4: '下单日期',
  delivery_date: '送货日期',
  delivery_date2: '交货日期',
  delivery_date3: '交货期',
  delivery_time: '送货时间',
  delivery_time2: '交货时间',
  order_flag: '订单记号',
  client_family_name: '客户姓氏',
  client_phone: '客户电话',
  other: '其他',
  extra_year: '额外一年保',
  area: '地区',
  area2: '区域',
  area3: '所在区域',
  update: '更新',
  update_man: '更新',
  start_time: '开始时间',
  end_time: '结束时间',
  invoice_date: '发票日期',
  invoice_date2: '开票日期',
  is_invoice: '开票',
  invoice_info: '开票资料',
  drilling_wall: '钻墙',
  handler: '经手人',
  uses: '用途',

  total_salary: '总薪金',
  base_salary: '底薪',
  commission: '佣金',
  special_bonus: '特别奖金',
  bonus: '奖金',
  maintain_commission: '维修佣金',
  maintain_expense: '维修支出',
  maintain_bonus: '维修奖金',
  maintenance_bonus: '保养奖金',
  maintenance_expense: '保养支出',
  maintenance_spare: '保养备用',

  type: '类型',
  type2: '类别',
  sundry_expenditure: '杂项支出',
  salary_expenditure: '薪金支出',
  fixed_expense: '固定支出',
  shop_expense: '店铺支出',
  extra_expense: '额外支出',
  netprofit: '纯利润',
  export_excel: '导出Excel',

  current_password: '当前密码',
  new_password: '新密码',
  print_invoice: '打印发票',
  job_title: '职位',
  supplier_name: '供货商名称',
  modify_time: '修改时间',
  last_modify_time: '最后修改时间',
  for_delivery: '待送货',
  processing: '处理中',
  total_sales_volume: '总销量',
  a_month_total_sales_volume: '一个月总销量',
  difference_quantity: '差额',
  replenish_application: '补货申请',
  application_quantity: '申请数量',
  audit_quantity: '审核数量',
  replenish_quantity: '补货数量',
  replenish_amount: '补货金额',
  estimated_date: '预计到货日期',

  project: '项目',
  project2: '工程',
  project_no: '工程号',
  project_category: '项目分类',
  project_code: '项目编号',
  project_name: '项目名称',
  project_address: '项目地址',
  deduct: '扣除',
  bank: '银行',
  account_name: '账户名称',
  account_no: '账户号码',

  maintenance_status: '维修状态',
  notification_status: '通知状态',
  expected_finish_day: '预计完成日',
  income_expenditure: '收入/支出',
  amount_mop: '金额/MOP',
  amount_hk: '金额/HK',
  reimbursement_people: '报销人',
  month_sell_quantity: '月销量',
  sales_volume: '销量',
  version: '版本',

  //Table分页文字
  table_jump_to: '到第',
  table_page: '页',
  table_go: '确定',
  table_total: '共',
  table_item: '条',
  table_limit_each_page: '条/页',

  password: '密码',
  verify_password: '验证密码',
  login_name: '登录名',
  nickname: '昵称',
  user_nickname: '用戶昵称',

  summary: '摘要',
  bank_name: '银行名称',
  bank_name2: '开户行',
  bank_card_no: '银行卡号',
  balance: '余额',
  balance_mop: '余额/MOP',
  balance_hk: '余额/HK',
  account_holder: '开户人',
  last_period_balance: '上期结余',
  last_period_balance2: '上期余额',

  //Table Title文字
  id: 'ID',
  amount: '金额',
  price: '单价',
  quantity: '数量',
  goods_code: '货品编号',
  goods_name: '货品名称',
  goods_code2: '商品编号',
  goods_name2: '商品名称',
  is_audit: '审核',
  electroplate: '电镀',
  is_electroplate: '电镀',
  polishing: '抛光',
  is_polishing: '抛光',

  receivable: '应收金额',
  payable: '应付金额',
  deposit: '订金',
  title: '标题',
  special_price: '特价',

  // 仓库
  leader: '负责人',
  tel: '电话',
  location: '位置',

  //维修单
  acceptance_date: '受理日期',
  client_name: '客人名称',
  client_name2: '客户名称',
  acceptance_model: '受理机型',
  serial_number: '串号',
  serial_number2: '序号',
  serial_number3: '编号',
  graphic_lock: '图形锁',
  maintain_history: '维修历史',
  warranty_status: '保修状态',
  follow_parts: '随机配件',
  fault_cause: '故障原因',
  fault_phenomenon: '故障现象',
  need_parts: '所需配件',
  maintain_evaluate: '维修估价',
  advance_payment: '预交款',
  spare_phone: '备用手机',
  spare_model: '备用机型',
  retrieve_date: '取机日期',
  acceptance_status: '受理状态',

  choose_delivery_note: '选择送货单',
  export_pdf: '导出PDF',
  export_list: '导出列表',
  export_monthly_analyze: '导出月份分析',
  reinforcemoney: '保固金',
  reminder_date: '提醒日期',
  total_money: '总金额',
  incomepay_type: '收支类别',
  difference_cost: '差额成本',
  sell_date: '销售日期',
  setting_sales_volume: '设定销量',
  negative_difference_quantity: '负差额',
  exchange_rate: '汇率',

  product_category: '产品分类',
  product_category2: '产品类别',
  product_category3: '成品分类',
  product: '产品',
  product2: '成品',
  problem_type: '问题类型',
  item_count: '项目总数',
  function: '功能',
  handling_type: '处理类型',
  handling_description: '处理描述',

  audited: '已审核',
  unaudited: '未审核',
  all: '全部',
  credit: '贷款',
  repayment: '还款',
  credit_amount: '贷款金额',
  repayment_amount: '还款金额',
  pay_type: '支付类型',
  paid: '已付款',
  unpaid: '未付款',
  make_journal: '生成日记账',
  cash_journal: '现金日记账',
  bank_journal: '银行日记账',
  invoice_journal: '支票日记账',
  receive_reminder: '接收提醒',
  income: '收入',
  total_income: '总收入',
  expenditure: '支出',
  last_in_cost: '最近入库成本',
  stock_cost: '仓存成本',
  cash_balance_mop: '现金余额MO',
  cash_balance_hk: '现金余额HK',
  bank_balance_mop: '银行余额MO',
  bank_balance_hk: '银行余额HK',
  invoice_balance_mop: '支票余额MO',
  invoice_balance_hk: '支票余额HK',
  check_no: '支票号',
  is_get: '是否已领取',
  is_get2: '已领取',
  not_get: '未领取',
  payment_entry: '付款录入',
  payment_type: '付款类型',
  payment_type2: '收付款类型',
  show_index: '显示序号',
  quote_remark: '报价备注',

  greater_than_zero: '大于0',
  equal_to_zero: '等于0',
  less_than_zero: '小于0',
  greater_than_zero2: '>0',
  equal_to_zero2: '=0',
  less_than_zero2: '<0',

  previous_day: '前一天',
  purchase_in: '采购入库',
  purchase_return: '采购退货',
  stock_transfer_out: '转仓出',
  consignment_out: '寄卖发出',
  consignment_in: '寄卖退货',
  retail: '零售',
  retail_return: '零售 - 退货',
  stock_adjust: '库存调整',
  current_day: '当前日期',
  add_deposit: '增加订金',
  order_quantity: '预订数量',
  order_quantity2: '订单数量',
  arrival_date: '到货日期',
  picture: '图片',
  goods_detail: '货品详情',
  goods_detail2: '商品详情',
  spec_parameter: '规格/参数',
  spec_parameter2: '规格参数',
  extend_price: '扩展单价',
  open_time: '营业时间',
  booking: '预订',
  new_product: '新品',
  spot_sale: '现货发售',
  is_corporate_account: '是否公账',
  corporate_account: '公账',
  keep_accounts: '记账',
  sort: '分类',
  miniprogram: '小程序',
  miniprogram_price: '小程序单价',
  delivery_way: '配送方式',
  service: '服务',
  value_added_services: '增值服务',
  extended_warranty: '延长保修',
  size: '尺码',
  size2: '尺寸',
  month: '月',
  month2: '月份',
  day: '天',
  send: '发送',
  detail_address: '详细地址',
  delivery_place: '出货地点',
  contracted_address: '简约地址',
  job_content: '工作内容',
  foreign_name: '外文名',
  spec: '规格',
  spec2: '规格型号',
  product_code: '产品编号',
  product_code3: '成品编号',
  product_name: '产品名称',
  product_name3: '成品名称',
  product_spec: '产品规格',
  product_spec2: '产品型号',
  product_spec3: '成品型号',
  stuff_code: '材料编号',
  stuff_name: '材料名称',
  stuff_spec: '材料规格',
  stuff_spec2: '材料规格型号',
  material_code: '材料编号',
  material_code2: '物料编号',
  material_name: '材料名称',
  material_name2: '物料名称',
  material_spec: '材料规格',
  material_spec2: '材料规格型号',
  material_spec3: '物料规格',
  goods_spec: '货品规格',
  goods_spec2: '货品规格型号',
  semi_finished_code: '半成品编号',
  semi_finished_name: '半成品名称',
  semi_finished_spec: '半成品规格',
  semi_finished_spec2: '半成品规格型号',
  system_item_can_not_edit: '系统项目,不能修改',
  system_item_can_not_delete: '系统项目,不能删除',
  uses: '用途',
  supply_code: '供应代码',
  is_occupy_can_not_unaudit: '已被占用，不能反审',
  receive_payment_date: '收款日期',
  payment_date: '付款日期',
  delivery_no: '送货单号',
  reconcile_date: '对账日期',
  reconcile_month: '对账月份',
  receipt_date: '单据日期',
  receipt_start_date: '单据开始日期',
  receipt_end_date: '单据结束日期',
  short_name: '简称',
  client_short_name: '客户简称',
  supply_type: '供货类型',
  sell_type: '销售类型',
  stuff: '材料',
  material: '材料',
  semi_finished: '半成品',
  semi_finished_product: '半成品',
  client_order_no: '客户订单号',
  sell_order_no: '销售订单号',
  maker: '制单',
  auditor: '审核',
  auditor2: '审核人',
  audit_date: '审核日期',
  time_unit_price: '工时单价',
  delivery_quantity: '交货数量',
  delivery_quantity2: '送货数量',
  owe_quantity: '欠数',
  order_amount: '订单金额',
  total_man_hour: '总工时',
  production_date: '生产日期',
  person_number: '人数',
  person_man_hour: '人员工时',
  man_hour: '工时',
  material_price: '物料价',
  check_stock: '检查库存',
  packages: '件数',
  is_xcx: '是否小程序',
  is_web: '是否网站',
  stock: '库存',
  handling_method: '处理方法',
  problem: '问题',
  guarantee_clause: '保修条款',
  privacy_policy: '隐私条款',
  user_agreement: '用户协议',
  user_guide: '用户指南',
  contact_us: '联系我们',

  create_date: '创建日期',
  create_time: '创建时间',
  create_by: '开单人',
  create_by2: '创建人',
  creater: '创建人',
  application_date: '申请日期',
  application_date2: '申请时间',
  modify_date: '修改日期',
  clear: '清除',

  edit_mode: '编辑模式',
  close_other: '关闭其他',
  close_all: '关闭全部',
  close_this: '关闭当前',

  start_date: '开始日期',
  end_date: '结束日期',
  select_week: '选择周',
  query_condition: '查询条件',

  stock_limit: '库存上限',
  stock_lower: '库存下限',
  mini_stock: '最小库存',
  safe_stock: '安全库存',
  max_stock: '最大库存',
  add_material: '加料',
  add_material_money: '加料金额',
  turnover: '营业额',
  sales_ranking: '销量',
  total_sales_ranking: '总销量',
  stock_location: '仓位',
  yesterday: '昨天',
  today: '今天',
  this_month: '当月',
  a_month: '一个月',
  last_month: '上个月',
  this_year: '今年',
  last_year: '去年',
  setmeal: '套餐',
  process: '工序',
  process2: '工艺',
  length: '长度',
  height: '高',
  height2: '高度',
  chipset: '芯片',
  chipset2: '机芯',
  hour_minute_hand: '时分针',
  second_hand: '秒针',
  finished: '已完成',
  unfinished: '未完成',
  sell_out_quantity: '销售数量',
  sell_out_quantity2: '出货数量',
  wechat: '微信',
  consignment_category: '寄售分类',
  order_no: '订单号',
  stock_quantity: '库存数量',
  is_used: '已使用',
  used: '已使用',
  unused: '未使用',
  subtotal: '小计',
  sell_out_date: '出货日期',
  sheets: '片数',
  pieces: '支数',
  backup: '备份',
  spare: '士啤',
  floor: '楼层',
  category_type: '分类类型',

  grade: '等级',
  auto_coding: '自动编码',
  manual_coding: '手动编码',
  hour: '小时',
  hour2: '时',
  minute: '分钟',
  minute2: '分',
  sceond: '秒',
  negotiation_date: '洽谈日期',
  negotiator: '洽谈人',
  next_date: '下次日期',
  next_content: '下次內容',
  is_connected: '已联系',
  final_date: '完成日期',
  final_time: '完成时间',
  task_executor: '任务执行人',
  take_time: '用时',
  task_content: '任务内容',
  tester: '测试员',
  task_finish_type: '任务完成类型',
  finish_flag: '完成标记',
  issue_category: '问题分类',
  issue_collection: '问题收集',
  issue_content: '问题内容',
  project_status: '项目状态',
  create_task: '生成任务',
  service_name: '服务名称',
  service_item: '服务项目',
  service_details: '服务详情',
  service_fee: '服务费',
  active_status: '在职状态',
  staff: '员工',
  staff_code: '员工编号',
  staff_name: '员工姓名',
  task_type: '任务类型',
  default_price: '默认单价',
  default_purchase_price: '默认采购价',
  default_sell_price: '默认销售价',
  material_category: '材料分类',
  material_category2: '物料分类',
  semi_finished_category: '半成品分类',
  addressee: '收货人',
  receipt_date: '收货日期',
  delivery_person: '送货人',
  remaining_quantity: '剩余数量',
  remaining_quantity2: '结余数量',
  finish_quantity: '完成数量',
  inventory_quantity: '入库数量',
  stock_in_type: '转仓入类型',
  stock_out_type: '转仓出类型',
  molds: '模具',
  molds2: '模条',
  card_slot: '卡位',
  formula: '公式',
  formula2: '配方',
  modifier: '修改人',
  diffuser: '扩散剂',
  sell_order: '销售订单',
  unit_quantity: '单位数量',
  production_order: '生产计划',
  sex: '性别',
  birthday: '生日',
  id_card: '身份证',
  department: '部门',
  hiredate: '入职日期',
  salesman: '业务员',
  salesman2: '业务',
  calc_attendance: '计算考勤',
  attendance: '考勤',
  production_no: '生产单号',
  category_code: '分类编码',
  client_product_code: '客户产品编码',
  client_product_code2: '客户成品编码',
  buyer: '采购员',
  purchase: '采购',
  client_order: '客户订单',
  sell_billing: '销售开单',
  client_return: '客户退货',
  sell_summary: '销售汇总',
  yield_rate: '良品率',
  stock_alert: '库存预警',
  inspection_type: '检验类型',
  product_description: '产品描述',
  inspection_quantity: '检验数量',
  inspector: '检验人',
  inspector2: '检验员',
  inspection_result: '检验结果',
  inspection_remark: '检验备注',
  overdue: '逾期',
  audit_time: '审核时间',
  customer_complaint: '客诉',
  process_result: '处理结果',
  defect_rate: '不良率',
  improvement_plan: '改善方案',
  wilfulness: '负责人',
  month_of_payment: '货款月份',
  invoice_money: '开票金额',
  invoice_money2: '发票金额',
  recorder: '记录人',
  analyst: '分析人',
  logger: '录入员',
  reason_for_sending_samples: '送样原因',
  sample_name: '样板名称',
  material_process: '材料工艺',
  producer: '制作员',
  rewards: '奖励',
  punishments: '惩罚',
  points: '积分',
  order_review: '订单评审',
  quality_manage: '品质管理',
  material_inspection: '材料检验',
  material_inspection2: '来料检验',
  product_inspection: '产品检验',
  admin_manage: '行政管理',
  attendance_entry: '考勤录入',
  overtime_entry: '加班录入',
  wage_entry: '工资录入',
  wage_date: '工资日期',
  wage_month: '工资月份',
  outsource_supplier_category: '外发供应商分类',
  outsource_supplier: '外发供应商',
  outsource_count: '外发统计',
  outsource_statement: '外发对账单',
  outsource_return: '外发退料',
  cost_estimation: '成本估算',
  feedback: '反馈',
  client_feedback: '客户反馈',
  improve: '改进',
  improve_plan: '改进计划',
  base_data: '基础数据',
  clear_image: '清除图片',
  production_quantity: '生产数量',
  order_type: '订单类别',
  parameter: '参数',
  packaging: '打包',
  packaging_reqs: '打包要求',
  package_spec: '打包规格',
  package_quantity: '打包数量',
  purchase_dep: '采购部',
  production_dep: '生产部',
  quality_dep: '品质部',
  mold_number: '模具号',
  client_remark: '客户备注',
  shift: '班次',
  shift2: '轮班',
  coefficient: '系数',
  process_route: '工艺路线',
  process_tech: '工艺工序',
  process_list: '工序列表',
  defective_items: '不良品项',
  out_quantity: '出库数量',
  in_quantity: '入库数量',
  reporting_auth: '报工权限',
  reporting_date: '报工日期',
  planned_date: '计划完成日期',
  planned_completion_date: '计划完成日期',
  plan_final_date: '计划完成日期',
  receiver: '收款人',
  payer: '付款人',
  return_goods: '返回货品',
  return_quantity: '退货数量',
  return_quantity2: '返回数量',
  return_date: '退货日期',
  return_date2: '归还日期',
  acceptable_quantity: '良品数',
  defective_quantity: '不良品数',
  uration: '时长',
  attendance_type: '考勤类型',
  net_pay: '实发工资',
  piecework: '计件',
  overtime: '加班',
  earnings: '增加项',
  social_insurance: '社保',
  deductions: '减少项',
  earnings_type: '增加项类型',
  earnings_entry: '增加项录入',
  deductions_type: '减少项类型',
  deductions_entry: '减少项录入',
  designator: '位号',
  sales_manager: '业务主管',
  is_sales_manager: '业务主管',
  order_coordinator: '跟单',
  is_order_coordinator: '跟单',
  order_manager: '跟单主管',
  is_order_manager: '跟单主管',
  accident_ins: '意外保险',
  buy_accident_ins: '购买意外保险',
  accident_date: '意外险日期',
  buy_accident_date: '购买意外险日期',
  buy_social_ins: '购买社保',
  health_report: '体检报告',
  project_dept: '所属项目部门',
  exp_status: '经验状态',
  edu: '学历',
  edu_major: '所学专业',
  age: '年龄',
  marital: '婚姻状态',
  work_years: '工龄',
  contract_date: '签署合同日期',
  resign_apply: '申请离职',
  resign_apply_date: '申请离职日期',
  resign_date: '离职日期',
  uniform_date: '制服领取日期',
  uniform_date2: '工衣领取日期',
  emergency_phone: '紧急联系人联系方式',
  reg_addr: '户籍地址',
  purchase_order_reminder: '采购订单提醒',
  remind: '提醒',
  delayed_reminder: '延时提醒',
  Select_delay_time: '选择延迟时间',
  purchase_in_serial_no: '采购入库单号',
  counterparty: '对接单位',
  counterparty2: '交易方',
  client_quotation: '客户报价',
  sample_sheet: '送样单',
  required_quantity: '要求数量',
  sample_quantity: '送样数量',
  remote_control: '配套遥控',
  accessories: '配件',
  sample_request_date: '下样板日期',
  sample_delivery_date: '送样日期',
  production_method: '出品方式',
  sample_feedback_record: '样板回访记录',
  standard: '标准',
  material_image: '板材图片',
  voltage: '电压',
  project_initiation: '立项单',
  product_name2: '产品命名',
  project_start_date: '立项时间',
  eval_drawing_completion: '评估画板完成时间',
  eval_closing: '评估结案时间',
  actual_drawing_date: '实际画板时间',
  actual_closing_date: '实际结案时间',
  dev_code: '开发代码',
  customer_code: '客户代码',
  full_data_date: '齐开发资料时间',
  design_dev_description: '设计开发内容描述',
  dev_requirement: '开发要求描述',
  electrical_requirements: '电气特性要求',
  input_voltage: '输入电压',
  output_spec: '输出规格',
  safety_req: '安规要求',
  esd_req: 'ESD要求',
  hipot_test_standard: '高压测试标准',
  project_initiation_serial_no: '立项单号',
  sample_status: '样板状态',
  exception_record: '异常单记录',
  batch: '批量',
  production_unit: '生产单位',
  product_type: '产品类型',
  product_type2: '成品类型',
  defect: '缺陷',
  defect_symptom: '缺陷症状',
  responsibility_judgment: '责任判断',
  feedback_department: '反馈部门',
  feedback_person: '反馈人',
  feedback_date: '反馈日期',
  defect_reason: '不合格原因',
  defect_reason_confirmer: '不合格原因确认人',
  defect_reason_confirmed_date: '不合格原因确认日期',
  action_plan: '处理方案',
  action_plan_confirmer: '处理方案确认人',
  action_plan_confirmed_date: '处理方案确认日期',
  qa_countersign: '品质部门会签',
  qa_countersign_confirmer: '品质部门会签确认人',
  qa_countersign_confirmed_date: '品质部门会签确认日期',
  action_status: '措施实施情况',
  action_standardization: '措施标准化',
  action_confirmer: '措施确认人',
  action_confirmed_date: '措施确认时间',
  action_auditor: '措施审核人',
  action_audited_date: '措施审核时间',
  production_plan: '生产计划',
  production_plan_serial_no: '生产计划单号',
  place: '地点',
  person_count: '人数',
  requester: '申请人',
  eng_docs_archive: '工程资料归档',
  archive_type: '归档类型',
  document: '文档',
  doc_name: '文档名称',
  image_name: '图片名称',
  product_packaging_management: '产品包装管理',
  label_note: '标贴说明',
  to_department: '派送部门',
  sampling_quantity: '抽检数量',
  check_date: '检查日期',
  check_requirement: '检查要求',
  purchase_order: '采购订单',
  stain: '污渍',
  damage: '破损',
  deformation: '变形',
  scratch: '划痕',
  dimension_mismatch: '尺寸不符',
  color_difference: '色差',
  qty_weight_discrepancy: '数量/重量 明显误差',
  material_function_mismatch: '材质/功能/参数 与订单不符',
  outer_pack_damage: '外包装破损',
  outer_pack_stain: '外包装污渍',
  inspection_date: '检验日期',
  engineering_dept: '工程部',
  production_dept: '生产部',
  qa_dept: '品质部',
  handling_result: '处理结果',
  action_opinion: '处理意见',
  final_action_opinion: '最终处理意见',
  final_action_opinion_signed_by: '最终处理意见签名',
  final_action_opinion_date: '最终处理意见日期',
  signed: '签名',
  signature_date: '签名日期',
  first_article_inspection: '首件检验',
  first_article_inspection_type: '首件检验类型',
  process_inspection: '过程检验',
  confirmation_purpose: '确认目的',
  production_line: '生产线',
  eco_friendly: '是否环保',
  voltage_frequency: '电压/频率',
  appearance: '外观',
  inspection_confirmer: '检验确认人',
  defective_remark: '不良备注',
  confirmer: '确认人',
  patrol: '巡查',
  patrol_date: '巡查日期',
  abnormal_description: '异常现象描述',
  patrol_inspector: '巡检员',
  cause_analysis: '原因分析',
  improvement_action: '改善措施',
  filled_by: '填写人',
  inspection_item: '检验项目',
  problem_description: '问题描述',
  components: '元器件',
  remote_distance: '遥控测距',
  durability: '耐久性',
  voltage_fluctuation: '电压波动',
  standby_power: '待机功率',
  flame_retardant: '阻燃',
  fatal: '致命',
  major: '主要',
  minor: '次要',
  sampling_result: '抽检结果',
  defective_quantity: '不良数',
  measured_defective_quantity: '实测不良数',
  review_result: '会议结果',
  material: '材料资料',
  material2: '物料资料',
  project_manage2: '工程管理',
  material_stock2: '物料库存',
  no_file: '无文件',
  doc_count: '文档数量',
  img_count: '图片数量',
  client_category: '客户分类',
  client_code: '客户代码',
  production_standard: '生产标准',
  client_sort_name: '客户简称',
  billing_month: '账单月份',
  payment_status: '收款状态',
  payment_responsible: '收款负责人',
  order_responsible: '跟单负责人',
  data_processing_completed: '数据处理完成',
  data_processing_failed: '数据处理失败',
  year: '年份',
  business_license: '营业执照',
  material_cycle: '物料周期',
  inventory_count: '盘点数量',
  picking_date: '领料日期',
  usage_quantity: '用量',
  required_quantity: '所需数量',
  issued_quantity: '实发数量',
  remaining_quantity: '剩余数量',
  outsource_type: '外发类型',
  outsource_inquiry: '外发询价',
  outsource_inquiry2: '外发采购询价',
  production_process: '生产工艺',
  plan_start_date: '计划上线日期',
  plan_start_date2: '计划开始日期',
  tin_bar: '锡条',
  tin_bar_in: '锡条入库',
  tin_bar_out: '锡条出库',
  tin_bar_in_out_count: '锡条出入库统计',
  tin_wire: '锡线',
  tin_wire_in: '锡线入库',
  tin_wire_out: '锡线出库',
  tin_wire_in_out_count: '锡线出入库统计',
  tin_powder: '锡灰',
  tin_powder_recycle: '锡灰回收',
  tin_powder_out: '锡灰出库',
  tin_powder_in_out_count: '锡灰出入库统计',
  tin_dross: '锡渣',
  tin_dross_recycle: '锡渣回收',
  tin_dross_out: '锡渣出库',
  tin_dross_in_out_count: '锡渣出入库统计',
  material_receiver: '领料人',
  machine: '机台',
  operator: '使用人',
  source_stock: '原库存',
  abnormal_quantity: '异常数量',
  abnormal_description: '异常描述',
  remaining_stock: '结余库存',
  in_date: '入库日期',
  out_date: '出库日期',
  sampling_plan: '抽样方案',
  production: '生产',
  quality_control: '品管',
  general_manager: '总经理',
  outsource_quantity: '外发数量',
  outsource_time: '外发时间',
  latest_material_arrival_time: '最迟物料到货时间',
  is_material_ready: '是否齐料',
  customer_final_delivery_date: '客户最终要求交期',
  ai_method: 'AI方式',
  smt_method: '贴片方式',
  bag: '袋子',
  piece_count: '个数',
  piece_count2: '件数',
  total_weight: '总重量',
  roll_count: '卷数',
  insertion: '插件',
  outsource_point: '外发加工点数',
  point_price: '点数单价',
  point_amount: '点数金额',
  minimum_charge: '最低消费',
  reported_person_count: '报工人数',
  wait: '等待',
  is_wait: '是否等待',
  wait_type: '等待类型',
  work_duration: '报工时长',
  work_duration2: '工长',
  pricing_method: '计价方式',
  wage_price: '工资单价',
  estimated_wage: '预计工资',
  process_price: '工序单价',
  finished_quantity: '完成数量',
  finished_percent: '完成比',
  percent: '百分比',
  price_in: '含税单价',
  price_ex: '不含税单价',
  amount_in: '含税金额',
  amount_ex: '不含税金额',
  disc_in: '含税优惠价',
  disc_ex: '不含税优惠价',
  manufact_cost: '制造成本',
  product_param: '产品参数',
  case_size: '外壳尺寸',
  power_lead: '电源引线',
  power_lead_input: '电源引线-输入',
  power_lead_output: '电源引线-输出',
  label: '标签',
  purchase_quote: '采购报价',
  outsourced_supplier_stock: '外发供应商库存',
  stock_in: '入库',
  stock_out: '出库',
  month_total: '本月合计',
  last_month_balance: '上月结存',
  material_stock_month: '材料月度库存',
  material_stock_month2: '物料月度库存',
  product_stock_month: '产品月度库存',
  process_pricing_method: '工序计价方式',
  piecework_unit: '计件单位',
  alt_model: '代替型号',
  supplier_model: '供应商型号',
  bom_setting: 'BOM设置',
  bom_setting_history: 'BOM历史记录',
  drawing_code: '图纸编码',
  audit_permissions: '审核权限',
  lighting_function: '灯光功能',
  border_color: '边框颜色',
  production_cycle: '生产周期',
  payment_cycle: '付款周期',
  collection_cycle: '收款周期',
  purchase_transit: '采购在途',
  payment_reminders: '付款提醒',
  collection_reminders: '收款提醒',
  income_type: '收入类型',
  income_entry: '收入录入',
  expense_type: '支出类型',
  expense_entry: '支出录入',
  profit_report: '利润表',
  expense_month: '费用月份',
  gross_profit: '毛利',
  gross_rate: '毛利率',
  net_profit: '净利润',
  sale_amount: '销售金额',
  cost_amount: '成本金额',
  expense_money: '费用金额',
  purchase_out: '采购出库',
  product_model: '产品型号',
  internal_no: '内部单号',
  material_list: '材料列表',
  delivery_method: '发货方式',
  gd_manager: '工单管理员',
  keys_manage: '钥匙管理',
  custodian: '保管人',
  equipment_name: '设备名称',
  person_in_charge: '负责人',
  news: '新闻',
  cover: '封面',
  cover_image: '封面图片',
  keywords: '关键词',
  transport_method: '运输方式',
  min_pack: '最小包装',
  lead_time: '交货周期',
  quoter: '报价人',
  contact_phone: '联系电话',
  publish_time: '发布时间',
  auto_publish_time: '自动发布时间',
  custom_discount: '自定义折扣',
  member_level: '会员等级',
  recharge_rules: '充值规则',
  member_recharge_rules: '会员充值规则',
  recharge_bill: '充值账单',
  member_recharge_bill: '会员充值账单',
  member_tag: '会员标签',
  balance_log: '余额日志',
  member_balance_log: '会员余额日志',
  points_log: '积分日志',
  member_points_log: '会员积分日志',
  is_finished: '是否完成',
  order_discount: '订单折扣',
  order_discount_config: '订单折扣设置',
  marketing_management: '营销管理',
  coupon_issuance_history: '优惠券发放历史',
  global_discount: '整单折扣',
  is_global_discount: '是否整单折扣',
  custom: '自定义',
  order_remark: '订单备注',
  substitute: '替代',
  substitute_material: '替代材料',
  substitute_material2: '替代物料',
  backup_time: '备份时间',
  in_transit: '在途',
  pending_pick: '待领料',
  suggest_quantity: '建议采购数量',
  operate: '操作',
  main_data: '主数据',
  sales_followup: '业务跟单',
  product_optimization_tracking: '产品优化跟踪',
  Precautionary_measures: '预防措施',
  measures_responsible: '措施负责人',
  file_name: '文件名称',
  situation_description: '情况描述',
  effectiveness_confirmation: '效果确认',
  validator: '验证人',
  confirm_date: '确认日期',
  specification_sheet: '规格书',
  paste: '粘贴',
  paste_image: '粘贴图片',
  paste_file: '粘贴文件',








  // 餐飲管理系統
  production_location: '制作位置',
  food_category: '食品类别',
  option: '选项',
  option_money: '选项金额',
  picture: '图片',
  food_material: '食材',
  food_material_category: '食材类别',
  table_number: '台号',
  member_category: '会员分类',
  member_group: '会员分组',
  recharge: '充值',
  give_away: '赠送',
  card_number: '卡号',
  food_name: '食品名称',
  food: '食品',
  shelf_life: '保质期',
  main_currency: '主货币',
  number_of_people: '人數',
  extra_order: '加菜',
  settlement: '结算',
  share_table: '拼台',
  change_table: '转台',
  car_info: '车辆信息',
  driver_info: '司机信息',
  service_record: '服务记录',
  open_cash_drawer: '打开钱箱',
  checklist: '查单',
  handover: '交班',
  production_location_setting: '制作位置设置',



  // 提示
  confirm_save: '确定保存',
  confirm_cancel: '确定取消',
  confirm_delete: '确定删除',
  confirm_audit: '确定审核',
  confirm_unaudit: '确定反审',
  confirm_obsolete: '确定作废',
  confirm_transfer_in: '确定转入',
  confirm_print: '是否打印',

  please_choose_detail: '请选择明细',
  please_choose_data: '请选择数据',
  please_choose_payment_method: '请选择结算方式',
  please_choose_client: '请选择客户',
  please_choose_audited_data: '请选择已审核的数据',
  please_enter_login_name: '请输入登录名',
  please_enter_password: '请输入密码',
  please_enter_org: '请输入机构',
  org_error: '机构错误',

  save_success: '保存成功',
  save_failed: '保存失败',
  save_data_success: '保存数据成功',
  save_data_failed: '保存数据失败',
  delete_data_success: '删除数据成功',
  delete_data_failed: '删除数据失败',
  audit_data_success: '审核数据成功',
  audit_data_failed: '审核数据失败',
  unaudit_data_success: '反审数据成功',
  unaudit_data_failed: '反审数据失败',
  move_failed: '移动失败',

  success: '成功',
  failed: '失败',
  error: '错误',
  unknown_error: '未知错误',
  will_delete_all: '会删除所有下级数据',
  data_does_not_exist: '数据不存在',
  no_data: '无数据',
  no_matches_found: '未找到匹配项',
  prev_page: '上一页',
  next_page: '下一页',
  low_stocks: '库存不足',
  insufficient_payment: '付款金额不足',
  login_name_or_password_wrong: '登录名或密码错误',
  login_success: '登录成功',
  no_permission: '没有权限',
  password_not_match: '密码不匹配',
  password_changed_successfully: '修改密码成功',
  verify_password_not_match: '验证密码不匹配',
  can_not_have_special_characters: '不能有特殊字符',
  can_not_empty: '不能为空',
  password_must_be_less_than_12_digits_and_no_spaces: '密码必须小于12位，且不能出现空格',
  do_not_underline_at_the_beginning_and_end: '首尾不能出现下划线',
  this_value_already_exists: '该值已经存在',
  must_be_unique: "必须唯一",
  if_hold: '是否Hold单',
  data_not_found: '未找到对应数据',
  data_not_audited: '数据未审核',
  lower_than_minimum_retail_price: '不能低于最低零售价',
  invoice: '发票',
  proofreading_invoice: '对数发票',
  receipt: '收据',
  order_invoice: '预订发票',
  receipt_type: '单据类型',
  receipt_type2: '收款类型',
  change_client_well_del_all_continue: '重新选择客户，将会删除所有明细数据，并且不可恢复，是否继续',
  current_password_not_match: '当前密码不匹配',
  print_done: '打印完成',
  unselected_data: '未选择数据',
  process_success: '处理成功',
  process_failed: '处理失败',
  process_failed_please_try_agin: '处理失败，请重试',
  process_timeout_please_try_agin: '处理超时，请重试',
  process_error: '处理错误',
  copy_done: '复制成功',
  pay_amount_more_than_total_amount: '支付金额大于总金额',
  data_sent_successfully: '数据发送成功',
  invalid_email_format: '无效的E-mail格式',
  invalid_phone_format: '无效的电话格式',
  login_has_expired: '登录已过期，请重新登录',
  please_input_number_of_people: '请输入人数',
  please_input_quantity: '请输入数量',
  please_input_member_mobile: '请输入会员电话号码',
  please_input_money: '请输入金额',
  please_input_discount: '请输入折扣',
  maximum_level_exceeded: '超出最大层级',
  no_member_found: '查无该会员',
  please_choose_new_table: '请选择新餐台',
  print_service_not_enabled: '打印服务未打开',
  detail_data_can_not_empty: '明细数据不能为空',
  used_data_cannot_be_deleted: "已被使用的资料不能删除",
  must_be_unique_together: "必须是唯一的组合",
  image_upload_failed: "上传图片失败",
  image_size_cannot_be_larger_than: "图片不能大于：",
  video_size_cannot_be_larger_than: "视频不能大于：",
  export_success: '导出成功',
  export_failed: '导出失败',
  no_files_on_the_clipboard: '剪贴板中没有文件',
  no_image_files_on_the_clipboard: '剪贴板中没有图片文件',
  please_paste_the_image_file: '请粘贴图片文件',
  upload_failed_please_try_again: '上传失败，请重试',
  upload_successful: '上传成功',
  paste_successful: '粘贴成功',


  // 菜单
  menu_base_data: '基础资料',
  menu_goods_category: '货品分类',
  menu_goods_standard: '货品规格',
  menu_goods: '货品资料',
  menu_goods_category2: '商品分类',
  menu_goods_standard2: '商品规格',
  menu_goods2: '商品资料',
  menu_unit: '单位',
  menu_color: '颜色',
  menu_payment_method: '结算方式',
  menu_payment_method2: '支付方式',
  menu_brand: '品牌',
  menu_depart: '部门',

  menu_member_manage: '会员管理',
  menu_member_category: '会员分类',
  menu_member: '会员资料',
  menu_points_setting: '积分设置',
  menu_points_redeem: '积分兑换',

  menu_purchase_manage: '采购管理',
  menu_supplier_category: '供应商分类',
  menu_supplier: '供应商资料',
  menu_purchase_plan: '采购计划',
  menu_purchase_order: '采购订单',
  menu_purchase_apply: '采购申请',
  menu_purchase_in: '采购入库',
  menu_purchase_return: '采购退货',
  menu_purchase_auxiliary: '采购辅助表',
  menu_purchase_inquiry: '采购询价',
  menu_supplier_quotes: '供应商报价',

  menu_process_plant_category: '加工厂分类',
  menu_process_plant: '加工厂资料',
  menu_outsource_manage: '外发管理',
  menu_outsource_out: '外发加工',
  menu_outsource_in: '外发收回',
  menu_outsource_report: '外发报表',
  menu_outsource_manage2: '外加工管理',
  menu_outsource_out2: '外加工发出',
  menu_outsource_in2: '外加工收入',
  menu_oem_in: '代加工收入',
  menu_oem_out: '代加工发出',

  menu_consignment_manage: '寄卖管理',
  menu_consignment_out: '寄卖发出',
  menu_consignment_out_detail: '寄卖发出明细',
  menu_consignment_in: '寄卖退货',
  menu_consignment_in_detail: '寄卖发出明细',
  menu_consignment_proceeds: '寄卖收款',
  menu_consignment_proceeds_detail: '寄卖收款明细',
  menu_consignment_uncollected: '寄卖未收款',
  menu_consignment_proceeds_report: '寄卖收款报表',

  menu_stock_transfer_out: '转仓出',
  menu_stock_transfer_in: '转仓入',

  menu_warehouse_manage: '仓库管理',
  menu_warehouse: '仓库资料',
  menu_stock_search: '库存查询',
  menu_stock_check: '库存盘点',
  menu_stock_adjust: '库存调整',
  menu_waste_in: '废品入库',
  menu_waste_out: '废品出库',
  menu_smart_replenishment: '智能补货',
  menu_goods_assemble: '商品组装',
  menu_goods_split: '商品拆分',
  menu_other_stock_in: '其他入库',
  menu_other_stock_out: '其他出库',
  menu_stock_in_type: '入库类型',
  menu_stock_out_type: '出库类型',

  menu_production_manage: '生产管理',
  menu_workshop: '车间设置',
  menu_bom_setting: 'BOM设置',
  menu_production_plan: '生产计划',
  menu_production_list: '生产排单',
  menu_production_order: '生产订单',
  menu_production_picking: '生产领料',
  menu_production_return: '生产退料',
  menu_product_in: '产品入库',
  menu_product_in_detail: '产品入库明细',
  menu_transfer_auxiliary: '转货辅助表',

  menu_sell_manage: '销售管理',
  menu_wholesale_manage: '批发管理',
  menu_client_category: '客户分类',
  menu_client: '客户资料',
  menu_customer: '客户资料',
  menu_customer2: '客户信息',
  menu_client_contact: '客户联系人',
  menu_sell_order: '销售订单',
  menu_client_quote: '客户报价',
  menu_sell_out: '销售出库',
  menu_sell_out_detail: '销售出库明细',
  menu_sell_return: '销售退货',
  menu_client_order: '客户订单',
  menu_sell_billing: '销售开单',
  menu_client_return: '客户退货',
  menu_sell_summary: '销售汇总',

  menu_sundry_manage: '杂项管理',
  menu_sundry_category: '杂项分类',
  menu_sundry_entry: '杂项录入',
  menu_shop_sundry: '店铺杂支',
  menu_fixed_expense: '固定支出',
  menu_shop_expense: '店铺支出',
  menu_extra_expense: '额外支出',
  menu_salary_expenditure: '薪金支出',
  menu_expenditure_report: '支出报表',

  menu_finance_manage: '财务管理',
  menu_accountbook: '账簿设置',
  menu_receipt_entry: '收款录入',
  menu_payment_entry: '付款录入',
  menu_receivable: '应收账款',
  menu_payable: '应付账款',
  menu_receipt_voucher: '收款凭证',
  menu_payment_voucher: '付款凭证',
  menu_receivable_offset: '应收账款冲账',
  menu_payable_offset: '应付账款冲账',
  menu_other_receipt: '其他收款',
  menu_other_payment: '其他付款',
  menu_expenses_type: '费用类型',
  menu_expenses_entry: '费用录入',
  menu_supplier_account_balance: '供应商对账结余',
  menu_client_account_balance: '客户对账结余',

  menu_settlement_manage: '结算管理',

  menu_addressee: '收货人',
  menu_delivery_manage: '送货管理',
  menu_delivery_person: '送货人',
  menu_delivery_time: '送货时段',
  menu_non_delivery_date: '不可送货日期',
  menu_status: '状态',
  menu_delivery_note: '送货单',
  menu_delivery_billing: '送货开单',
  menu_delivery_billing_report: '送货开单报表',

  menu_maintain_manage: '维修管理',
  menu_acceptance_status: '受理状态',
  menu_maintenance_status: '维修状态',
  menu_notification_status: '通知状态',
  menu_maintain_note: '维修单',
  menu_reservation_maintain_note: '预约维修单',
  menu_maintain_note_report: '维修单报表',
  menu_reservation_maintain_note_report: '预约维修单报表',

  menu_system_setting: '系统设置',
  menu_operation_log: '操作日志',
  menu_system_param: '系统参数',
  menu_user_group: '用户组',
  menu_user: '用户资料',
  menu_change_password: '修改密码',

  menu_report: '报表',
  menu_goods_tracking: '货品跟踪',
  menu_purchase_in_report: '采购入库报表',
  menu_purchase_in_count: '采购入库统计',
  menu_stock_transfer_out_report: '转仓出报表',
  menu_stock_count: '库存统计',
  menu_retail_profit: '零售利润',
  menu_netprofit_report: '纯利表',
  menu_daily_settlement: '每日结算',
  menu_payment_method_daily: '每日结算-结算方式',
  menu_daily_settlement_variance: '每日结算差异',
  menu_retail_settlement: '零售结算',
  menu_retail_detail_report: '零售明细',
  menu_order_report: '预订报表',
  menu_order_detail: '预订明细',
  menu_order_statistics: '预订统计',
  menu_obsolete_report: '作废报表',
  menu_return_report: '退货报表',
  menu_loss_report: '损耗报表',
  menu_profit_report: '利润报表',
  menu_net_profit_report: '净利润报表',
  menu_purchase_detail: '采购明细',
  menu_sell_detail: '销售明细',
  menu_inventory_warning: '库存预警',
  menu_purchase_report: '采购报表',
  menu_replenish_manage: '补货管理',
  menu_replenish_application: '补货申请',

  menu_supplier_quote: '供应商报价',
  menu_purchase_receipt: '采购单',
  menu_object_manage: '项目管理',
  menu_quote_recipt_status: '报价单状态',
  menu_project_setting: '项目设定',
  menu_project_category: '工程分类',
  menu_project_category2: '项目分类',
  menu_negotiation_category: '洽谈分类',
  menu_project_negotiation: '项目洽谈',
  menu_project_info: '项目资料',
  menu_project_quote: '工程报价',
  menu_project_quote2: '项目报价',
  menu_project_invoice: '工程发票',
  menu_design_company_setting: '设计公司设定',
  menu_design_quote: '设计报价',

  menu_income_expenditure_manage: '收付款管理',
  menu_income_type: '收款类型',
  menu_expenditure_type: '付款类型',

  menu_currency: '币种',
  menu_bank_setting: '银行设定',
  menu_bank_journal_type: '日记账类别',
  menu_cash_journal_entry: '现金日记账录入',
  menu_bank_journal_entry: '银行日记账录入',
  menu_invoice_journal_entry: '发票日记账录入',
  menu_check_journal_entry: '支票日记账录入',
  menu_debit_credit_entry: '借贷录入',
  menu_debit_entry: '借款录入',
  menu_credit_entry: '贷款录入',
  menu_reimbursement_people: '报销人',
  menu_reimburse_entry: '报销录入',

  menu_project_quote_report: '工程报价报表',
  menu_design_quote_report: '设计报价报表',
  menu_receipt_report: '收款报表',
  menu_payment_report: '付款报表',
  menu_receipt_payment_detail: '收支明细',
  menu_project_receipt_payment_detail: '工程收支明细',
  menu_profit_report: '利润表',
  menu_cash_journal_report: '现金日记账报表',
  menu_bank_journal_report: '银行日记账报表',
  menu_invoice_journal_report: '发票日记账报表',
  menu_check_journal_report: '支票日记账报表',
  menu_debit_credit_report: '借贷报表',
  menu_reimburse_report: '报销报表',

  menu_project_follow_up: '项目跟进',
  menu_project_manage: '项目管理',
  menu_after_sale_manage: '售后管理',
  menu_after_sale: '售后',
  menu_customer_complaint: '客诉',
  menu_problem_collection: '问题收集',
  menu_problem_handling: '问题处理',
  menu_client_manage: '客户管理',
  menu_customer_manage: '客户管理',
  menu_receipt_type: '收款类型',
  menu_material_category: '材料分类',
  menu_product_category: '产品分类',
  menu_product_info: '产品数据',
  menu_semi_finished_category: '半成品分类',
  menu_semi_finished: '半成品资料',
  menu_area: '地区',
  menu_problem_type: '问题类型',
  menu_handling_type: '处理类型',
  menu_unfinished_problem: '未完成问题',
  menu_repayment_entry: '还款录入',
  menu_credit_repayment_entry: '贷款还款录入',
  menu_credit_report: '贷款报表',
  menu_purchase_check_report: '采购对数报表',
  menu_monthly_balance: '月结',
  menu_daily_balance_report: '日结报表',
  menu_daily_balance_detail: '日结明细',
  menu_edition_fee: '版费',
  menu_edition_fee_return: '版费退回',
  menu_staff_info: '员工资料',
  menu_settlement: '结算',
  menu_supplier_statement: '供应商对账单',
  menu_client_statement: '客户对账单',
  menu_attendance_manage: '考勤管理',
  menu_schedules_setting: '班次定义',
  menu_holiday_entry: '假日登记',
  menu_absence_type: '缺勤类型',
  menu_absence_entry: '缺勤登记',
  menu_special_record: '特殊记录',
  menu_attendance_entry: '考勤录入',
  menu_attendance_statistics: '考勤统计',
  menu_attendance_type: '考勤类型',

  menu_salary_manage: '工资管理',
  menu_process_setting: '工序设置',
  menu_process: '工序',
  menu_piecework_data_entry: '计件数据录入',
  menu_piecework_report: '计件报表',
  menu_salary_statistics: '工资统计表',
  menu_salary_report: '工资报表',
  menu_piecework_order: '计件订单',
  menu_piecework_entry: '计件录入',
  menu_wage_entry: '工资录入',

  menu_purchase_detail: '采购明细',
  menu_sell_detail: '销售明细',
  menu_stock_alert: '库存预警',
  menu_monthly_receivable_detail: '月份应收款往来',
  menu_monthly_payable_detail: '月份应付款往来',
  menu_cash_account: '现金账',
  menu_profit_statistics: '利润统计表',
  menu_supplier_manage: '供应商管理',
  menu_payment_type: '付款类型',
  menu_wx_mall: '微信商城',
  menu_sort: '分類',
  menu_order_status: '订单状态',
  menu_wx_order: '微信订单',

  menu_size: '尺码',
  menu_order_management: '订单管理',
  menu_finished_order: '已完成订单',
  menu_product_stuff_search: '产品材料查询',
  menu_product_material_search: '产品材料查询',
  menu_unsalable_report: '滞销报表',
  menu_bad_goods_transfer_out: '坏货转出',
  menu_terms_setting: '条款设置',

  menu_task_type: '任务类型',
  menu_task_finish_type: '任务完成类型',
  menu_task: '任务',
  menu_project_progress: '项目进度',
  menu_issue_manage: '问题管理',
  menu_issue_category: '问题分类',
  menu_issue_collection: '问题收集',
  menu_material_stock: '材料库存',
  menu_product_stock: '产品库存',
  menu_sell_report: '销售报表',


  // 餐飲管理系統
  menu_food_setting: '食品设置',
  menu_food_category: '食品类别',
  menu_food_info: '食品资料',
  menu_food_material_category: '食材类别',
  menu_food_material: '食材资料',
  menu_option: '选项',
  menu_dining_table_setting: '餐台设置',
  menu_area2: '区域',
  menu_table_number: '台号',
  menu_recharge_offer: '充值优惠',
  menu_member_recharge: '会员充值',
  menu_recharge: '充值管理',
  menu_discount_manage: '折扣管理',
  menu_discount_manage2: '优惠管理',
  menu_discount: '折扣录入',
  menu_business_report_day: '营业日报',
  menu_business_report_month: '营业月报',
  menu_sales_ranking: '销量排行',
  menu_food_material_report: '食材报表',
  menu_param: '参数设置',
  menu_production_location: '制作位置',
  menu_service: '服务设置',

  menu_client_follow_up: '客戶跟進',
  menu_follow_up_type: '跟進類型',
  menu_follow_up_entry: '跟進錄入',
  menu_follow_up_report: '跟進情況表',
  menu_sell_offer: '销售报价',
  menu_purchase_offer: '采购报价',

  menu_product_catetory: '产品分类',
  menu_material: '材料资料',
  menu_product: '产品资料',
  menu_product2: '成品资料',
  menu_product_process: '产品工序',
  menu_personnel_manage: '人事管理',
  menu_department: '部门',
  menu_job_title: '职位',
  menu_job_post: '职位',
  menu_staff: '员工资料',
  menu_grade: '等级',

  menu_store_manage: '卖场管理',
  menu_goods_listing: '商品上架',
  menu_goods_drop: '商品下架',
  menu_retail_special: '零售特价',
  menu_member_special: '会员特价',
  menu_purchase_gift: '买送促销',
  menu_full_reduction_discount: '满减优惠',
  menu_special_package: '特价打包',
  menu_retail_return: '零售退货',
  menu_daily_flow_report: '每日流水报表',
  menu_setmeal: '套餐',
  menu_length: '长度',
  menu_height: '高度',
  menu_cash_coupon: '现金券',
  menu_coupon: '优惠券',
  menu_specials: '商品特价',
  menu_member_specials: '会员特价',
  menu_consignment_category: '寄卖分类',
  menu_post: '岗位',
  menu_active_status: '在职状态',

  menu_service_category: '服务分类',
  menu_service_manage: '服务管理',
  menu_trademark_category: '商标分类',
  menu_order_manage: '订单管理',
  menu_about_us: '关于我们',
  menu_stock_state: '库存状态',
  menu_inspection_report: '检验报告',
  menu_quality_control: '品质控制',
  menu_quality_inspection: '品质检验',
  menu_outgoing_inspection: '出货检验',
  menu_invoicing_record: '开票记录',
  menu_receipt_record: '收票记录',
  menu_Consumption_report: '消费报表',

  menu_goods_disassembly_assembly_manage: '商品拆装',
  menu_goods_disassembly: '商品拆分',
  menu_goods_assembly: '商品组装',
  menu_reserve_manage: '预约管理',
  menu_reserve_enter: '预约登记',
  menu_online_reserve: '在线预约',
  menu_reserve_dispatch: '预约调度',
  menu_reserve_reminder: '预约提醒',
  menu_service_manage: '服务管理',
  menu_work_order_state: '工单状态',
  menu_work_order_enter: '工单录入',
  menu_item_type: '项目类型',
  menu_item_setting: '项目设置',
  menu_collect_feedback: '收集反馈',

  menu_sample_record: '样板记录',
  menu_material_inspection: '材料检验',

  CREATE: '新增',
  UPDATE: '修改',
  DELETE: '删除',
  AUDIT: '审核',
  UNAUDIT: '反审',
  LOGIN: '登录',
  LOGOUT: '注销',
  log_time: '日志时间',
  log_date: '日志日期',
  log_detail: '日志明细',
  new_value: '新值',
  old_value: '旧值',
  no_log_data: '没有日志数据',
  change_item: '变更项',
  updated: '更新',
  inserted: '插入',
  deleted: '删除',
}